import { __exports as c } from "./contact-channels222.js";
import { __require as A } from "./contact-channels205.js";
var E;
function F() {
  if (E) return c;
  E = 1, Object.defineProperty(c, "__esModule", { value: !0 }), c.default = D;
  var q = A(), f = "html", l = "head", a = "body", S = /<([a-zA-Z]+[0-9]?)/, m = /<head[^]*>/i, y = /<body[^]*>/i, n = function(e, r) {
    throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
  }, s = function(e, r) {
    throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
  }, T = typeof window == "object" && window.DOMParser;
  if (typeof T == "function") {
    var M = new T(), b = "text/html";
    s = function(e, r) {
      return r && (e = "<".concat(r, ">").concat(e, "</").concat(r, ">")), M.parseFromString(e, b);
    }, n = s;
  }
  if (typeof document == "object" && document.implementation) {
    var i = document.implementation.createHTMLDocument();
    n = function(e, r) {
      if (r) {
        var o = i.documentElement.querySelector(r);
        return o && (o.innerHTML = e), i;
      }
      return i.documentElement.innerHTML = e, i;
    };
  }
  var u = typeof document == "object" && document.createElement("template"), d;
  u && u.content && (d = function(e) {
    return u.innerHTML = e, u.content.childNodes;
  });
  function D(e) {
    var r, o;
    e = (0, q.escapeSpecialCharacters)(e);
    var v = e.match(S), _ = v && v[1] ? v[1].toLowerCase() : "";
    switch (_) {
      case f: {
        var p = s(e);
        if (!m.test(e)) {
          var t = p.querySelector(l);
          (r = t == null ? void 0 : t.parentNode) === null || r === void 0 || r.removeChild(t);
        }
        if (!y.test(e)) {
          var t = p.querySelector(a);
          (o = t == null ? void 0 : t.parentNode) === null || o === void 0 || o.removeChild(t);
        }
        return p.querySelectorAll(f);
      }
      case l:
      case a: {
        var w = n(e).querySelectorAll(_);
        return y.test(e) && m.test(e) ? w[0].parentNode.childNodes : w;
      }
      // low-level tag or text
      default: {
        if (d)
          return d(e);
        var t = n(e, a).querySelector(a);
        return t.childNodes;
      }
    }
  }
  return c;
}
export {
  F as __require
};
//# sourceMappingURL=contact-channels204.js.map
